var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontedEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60984 7.61529C6.33136 6.87207 7.05179 6.14321 7.80397 6.40719L16.6154 9.4996C17.3703 9.76451 17.4678 10.7864 16.7766 11.1882L13.5591 13.0583L11.6206 16.5624L11.0714 16.2622M11.6206 16.5624C11.2329 17.2633 10.1967 17.188 9.91586 16.4386L6.60984 7.61529",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65259 2.6633C2.89197 2.41462 3.28873 2.40593 3.53877 2.6439L6.03627 5.02077C6.28631 5.25874 6.29495 5.65325 6.05557 5.90193C5.81619 6.15061 5.41943 6.1593 5.16939 5.92133L2.67189 3.54446C2.42184 3.30649 2.4132 2.91198 2.65259 2.6633Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11608 0.377489C8.46088 0.346995 8.76519 0.600203 8.79577 0.943044L9.09094 4.25198C9.12152 4.59482 8.86679 4.89747 8.52199 4.92796C8.17718 4.95845 7.87287 4.70525 7.84229 4.3624L7.54713 1.05347C7.51655 0.710632 7.77127 0.407983 8.11608 0.377489Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.375523 8.5008C0.345025 8.15795 0.599828 7.85536 0.94464 7.82495L4.27247 7.53147C4.61729 7.50106 4.92153 7.75434 4.95203 8.09719C4.98253 8.44004 4.72773 8.74262 4.38291 8.77303L1.05508 9.06652C0.710267 9.09693 0.40602 8.84365 0.375523 8.5008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontedEvent);
export default __webpack_public_path__ + "static/media/fronted-event.d713e618eec433d9d165bde9469c3a53.svg";
export { ForwardRef as ReactComponent };